import { AdminPageLayout } from "@/features/admin/components/AdminPageLayout";
import { AdminEntityPicker, AdminFilterField } from "@/features/admin/tables";
import { useNav } from "@/utils/nav";
import { ui } from "@patient-watch/ui";
import { createFileRoute, Link } from "@tanstack/react-router";
import { Eye } from "lucide-react";
import { z } from "zod";

const ViewDiaryAsPatientSearchZ = z.object({
    diaryId: z.string().optional(),
});

function ViewDiaryAsPatientPage() {
    useNav([
        { label: "Admin", route: { to: "/admin" } },
        { label: "Diary as patient", route: { to: "/admin/view-diary-as-patient" } },
    ]);

    const { diaryId } = Route.useSearch();
    const navigate = Route.useNavigate();

    return (
        <AdminPageLayout
            title="Diary as patient"
            description="Open a diary on the patient's home screen, to see their to-do list and results the way they do."
        >
            <div className="space-y-4 w-full">
                <AdminFilterField label="Diary" htmlFor="view-as-patient-diary">
                    <AdminEntityPicker
                        id="view-as-patient-diary"
                        entity="diary"
                        value={diaryId ?? null}
                        onChange={(next) => void navigate({ search: { diaryId: next ?? undefined }, replace: true })}
                    />
                </AdminFilterField>

                <p className="text-muted-foreground text-sm">
                    You stay signed in as yourself. Anything you fill in or change here is saved to the patient&apos;s
                    diary, so look but don&apos;t submit.
                </p>

                {diaryId ? (
                    <ui.Button asChild size="md">
                        <Link to="/diaries/$diaryId/home/to-do" params={{ diaryId }}>
                            <Eye className="w-4 h-4" />
                            View diary as patient
                        </Link>
                    </ui.Button>
                ) : (
                    <ui.Button size="md" disabled>
                        <Eye className="w-4 h-4" />
                        View diary as patient
                    </ui.Button>
                )}
            </div>
        </AdminPageLayout>
    );
}

export const Route = createFileRoute("/_app/admin/view-diary-as-patient")({
    component: ViewDiaryAsPatientPage,
    validateSearch: (search) => ViewDiaryAsPatientSearchZ.parse(search),
});
